import { ComponentFields, Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

import { LearningTypes } from 'src/enums/LearningTypes';

import { ContentDetailItem } from 'src/types/ContentDetailsItem';
import { ExtendedItem } from 'src/types/ExtendedItem';
import { ResourceListItem } from 'src/types/ResourceListItem';

import { parseAccessLevelRouteFields } from '../fields/parseAccessLevelContent';
import { parseAccessTypes, parseAccessTypesString } from '../fields/parseAccessTypes';
import { parseIsoDate } from '../fields/parseDate';
import { parseLearningFormats } from '../fields/parseLearningFormats';
import { parseTags } from '../fields/parseTags';
import { parseTypesOfResources, parseTypesOfResourcesString } from '../fields/parseTypesOfResources';
import { parseWildCardUrl } from '../fields/parseUrl';

export function mapCPDArticle(item: ExtendedItem, wildcardUrl?: string): ResourceListItem | null {
	try {
		if (!item) {
			return null;
		}

		return {
			Id: item.id,
			Title: (item.fields.Title as Field<string>).value,
			Strapline: (item.fields.Strapline as Field<string>)?.value,
			ImageUrl: item.fields.Image ? (item.fields.Image as ImageField).value?.src : '',
			LearningFormats: parseLearningFormats(item.fields.LearningFormat),
			TypesOfResources: parseTypesOfResources(item.fields.Tags),
			TypesOfResourcesString: parseTypesOfResourcesString(item.fields.Tags),
			Url: parseWildCardUrl(item.name, wildcardUrl),
			LearningType: LearningTypes.Resource.toString(),
			AccessTypes: parseAccessTypes(item.fields.AccessType),
			AccessTypesString: parseAccessTypesString(item.fields.AccessType),
			Tags: parseTags(item.fields.Tags),
			Location: (item.fields.Location as Field<string>)?.value,
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}

export function mapCPDArticleToContentDetails(
	id: string,
	fields: ComponentFields | undefined,
	RCNiSAMLIdPBaseUrl: string,
	RCNiMPSSSORelayStateParameterName: string,
	RCNiMPSSSOSpentityId: string,
	RCNiMPSSSOSpentityIdParameterName: string
): ContentDetailItem | null {
	try {
		if (!fields) {
			return null;
		}

		const reviewedDate = fields['DateOfLastReview'] ? parseIsoDate((fields['DateOfLastReview'] as Field<string>).value) : null;

		let url = '';
		try {
			url = `${RCNiSAMLIdPBaseUrl}
							?${RCNiMPSSSOSpentityIdParameterName}=${RCNiMPSSSOSpentityId}
							&${RCNiMPSSSORelayStateParameterName}=${(fields.RCNiArticleUrl as Field<string>).value}`;
		} catch (error) {
			console.error('Failed to calculate RCNi link' + error);
		}

		return {
			Id: id,
			Title: (fields.Title as Field<string>).value,
			Strapline: (fields.Strapline as Field<string>)?.value,
			ImageUrl: fields.Image ? (fields.Image as ImageField).value?.src : '',
			Tags: parseTags(fields.Tags),
			AccessTypes: parseAccessTypes(fields.AccessType),
			AccessTypesString: parseAccessTypesString(fields.AccessType),
			Access: parseAccessLevelRouteFields(fields),
			TypesOfResources: parseTypesOfResources(fields.Tags),
			TypesOfResourcesString: parseTypesOfResourcesString(fields.Tags),
			Information: (fields.Information as Field<string>).value,
			IsCpdArticle: true,
			IsLmsModule: false,
			IsLmsCourse: false,
			IsResource: false,
			DateReviewed: reviewedDate,
			LearningFormats: parseLearningFormats(fields.LearningFormat),
			CertificateOfCompletion: fields.CertificateOfCompletion && (fields.CertificateOfCompletion as Field<boolean>).value === true,
			ProfessionalLeads: { Text: (fields.ProfessionalLeads as Field<string>).value },
			ResourceSponsor: (fields.ResourceSponsor as Field<string>).value,
			PeerReviewed: fields.PeerReviewed && (fields.PeerReviewed as Field<boolean>).value === true,
			LearningTypeString: LearningTypes.Resource.toString(),
			LearningType: LearningTypes.Resource,
			Url: url,
			Cost: (fields.Cost as Field<string>).value,
			Location: (fields.Location as Field<string>)?.value,
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}
